import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var __jsx = React.createElement;
import React, { useState, createContext, useContext, useEffect, useRef } from "react";
import Modal from "./Modal";
import "./Modal.css";
import useIsMobile from "@hooks/useIsMobile";
var ModalContext = /*#__PURE__*/createContext(undefined);
export var useModal = function useModal() {
  var context = useContext(ModalContext);
  if (!context) {
    //throw new Error("useModal must be used within a ModalProvider");
  }
  return context;
};
var DEFAULT_MODAL_DESIGN_DESKTOP = {
  marginAroundPercentage: 70,
  closeAnimation: false
};
var DEFAULT_MODAL_DESIGN_MOBILE = {
  marginAroundPercentage: 0,
  closeAnimation: false
};
var ModalManager = function ModalManager(_ref) {
  var children = _ref.children,
    open = _ref.open,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose,
    screens = _ref.screens,
    _ref$modalDesign = _ref.modalDesign,
    modalDesign = _ref$modalDesign === void 0 ? {} : _ref$modalDesign,
    customClassName = _ref.customClassName,
    haveClose = _ref.haveClose,
    hideTitleBar = _ref.hideTitleBar,
    maxHeight = _ref.maxHeight,
    zeroHeightHead = _ref.zeroHeightHead,
    maxWidth = _ref.maxWidth,
    maxHeightDesktop = _ref.maxHeightDesktop,
    maxWidthDesktop = _ref.maxWidthDesktop;
  var isMobile = useIsMobile();
  modalDesign = _objectSpread(_objectSpread({}, isMobile ? DEFAULT_MODAL_DESIGN_MOBILE : DEFAULT_MODAL_DESIGN_DESKTOP), modalDesign || {});
  var _useState = useState(1),
    currentScreen = _useState[0],
    setCurrentScreen = _useState[1];
  var _useState2 = useState(false),
    isAnimating = _useState2[0],
    setIsAnimating = _useState2[1];
  var activeScreenRef = useRef(null);
  var _useState3 = useState(false),
    isClosing = _useState3[0],
    setIsClosing = _useState3[1];
  var _useState4 = useState(false),
    isExpanded = _useState4[0],
    setIsExpanded = _useState4[1];
  var _useState5 = useState(3),
    expansionLevel = _useState5[0],
    setExpansionLevel = _useState5[1];
  var _useState6 = useState(''),
    stepTitle = _useState6[0],
    setStepTitle = _useState6[1];
  var refPreviousScreenIndex = useRef(0);
  var goToScreen = function goToScreen(index) {
    setIsAnimating(true);
    setCurrentScreen(index);
    refPreviousScreenIndex.current = currentScreen;
  };
  var goToPreviousScreen = function goToPreviousScreen() {
    goToScreen(refPreviousScreenIndex.current);
  };
  var goToScreenByKey = function goToScreenByKey(screenKey) {
    var index = screens.findIndex(function (screen) {
      return screen.key === screenKey;
    });
    goToScreen(index + 1);
  };
  var closeModal = function closeModal() {
    if (!modalDesign.closeAnimation) {
      onClose();
    } else {
      setIsClosing(true);
    }
  };
  useEffect(function () {
    if (isAnimating && activeScreenRef.current) {
      var handleAnimationEnd = function handleAnimationEnd() {
        setIsAnimating(false);
        if (activeScreenRef.current) {
          activeScreenRef.current.classList.remove("fade-in");
        }
      };
      activeScreenRef.current.addEventListener("animationend", handleAnimationEnd);
      return function () {
        if (activeScreenRef.current) {
          activeScreenRef.current.removeEventListener("animationend", handleAnimationEnd);
        }
      };
    }
  }, [isAnimating]);
  useEffect(function () {
    if (isClosing) {
      var handleAnimationEnd = function handleAnimationEnd() {
        setIsClosing(false);
        onClose();
      };
      var modalElement = document.querySelector(".modal-content");
      if (modalElement) {
        modalElement.addEventListener("animationend", handleAnimationEnd);
        return function () {
          modalElement.removeEventListener("animationend", handleAnimationEnd);
        };
      }
    }
  }, [isClosing, onClose]);
  useEffect(function () {
    if (activeScreenRef !== null && activeScreenRef !== void 0 && activeScreenRef.current) {
      console.log('scrolling to top', activeScreenRef);
      activeScreenRef.current.scrollTop = 0;
    }
  }, [currentScreen, activeScreenRef]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModalContext.Provider, {
    value: {
      currentScreen: currentScreen,
      goToScreen: goToScreen,
      goToPreviousScreen: goToPreviousScreen,
      goToScreenByKey: goToScreenByKey,
      isClosing: isClosing,
      setIsClosing: setIsClosing,
      isExpanded: isExpanded,
      setIsExpanded: setIsExpanded,
      expansionLevel: expansionLevel,
      setExpansionLevel: setExpansionLevel,
      stepTitle: stepTitle,
      setStepTitle: setStepTitle
    }
  }, /*#__PURE__*/React.createElement(Modal, {
    modalDesign: modalDesign,
    isOpen: open,
    onClose: function onClose() {
      return closeModal();
    },
    screens: screens,
    customClassName: customClassName,
    haveClose: haveClose,
    hideTitleBar: hideTitleBar,
    maxHeight: maxHeight,
    zeroHeightHead: zeroHeightHead,
    maxWidth: maxWidth,
    maxWidthDesktop: maxWidthDesktop,
    maxHeightDesktop: maxHeightDesktop
  }, /*#__PURE__*/React.createElement("div", {
    className: "screen-container"
  }, React.Children.map(children, function (child, index) {
    return /*#__PURE__*/React.createElement("div", {
      ref: index + 1 === currentScreen ? activeScreenRef : null,
      key: "screen-".concat(index + 1),
      className: "screen ".concat(index + 1 === currentScreen ? "active" : "", " ").concat(isAnimating && index + 1 === currentScreen ? "fade-in" : "")
    }, child);
  })))));
};
export default ModalManager;